(function (app) {

    app.filter("usd",
        [
            function () {
                return function (value) {
                    if (value && value.length >= 1) {
                        return "$" + value;
                    }
                    return value;
                }
            }
        ]);

    app.filter("usdReverse",
        [
            function () {
                return function (value) {
                    if (value) return value.replace(/\$/g, "");
                    return value;
                }
            }
        ]);


})(window.app); //jshint ignore:line